'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const PdfViewer = dynamic(() => import('@src/components/coreUI/pdfViewer'), {
  ssr: false,
  loading: () => (
    <div className="flex justify-center items-center h-screen">
      <div className="w-[60px] h-[60px] border-2 border-[#f3f3f3] border-t-2 border-t-[#3498db] rounded-full animate-spin"></div>
    </div>
  ),
});

function Terms() {
  return (
    <div style={{ height: '100vh', width: '100vw' }}>
      <PdfViewer file="assets/pdf/zemeTerms.pdf" />
    </div>
  );
}

export default Terms;
